// extracted by mini-css-extract-plugin
export var actions = "_mg-d";
export var benefitCard = "_mg-a";
export var benefitIcon = "_mg-b";
export var benefitLabel = "_mg-c";
export var benefits = "_mg-9";
export var bodyText = "_mg-8";
export var closeButton = "_mg-2";
export var content = "_mg-3";
export var eyebrow = "_mg-4";
export var heading = "_mg-5";
export var image = "_mg-f";
export var imagePanel = "_mg-e";
export var modal = "_mg-0";
export var shell = "_mg-1";
export var title = "_mg-6";
export var titleOffer = "_mg-7";